// TODO: Add left arrow SVG
// @flow
import React from 'react'
import styled from 'styled-components'
import theme from 'styled-theming'
import { myTheme } from '../../../styles'

const { color } = myTheme
const arrowTheme = theme('mode', {
  light: color.lightBlueGray,
  dark: color.lightBlueGray,
})

type ArrowSVGProps = {
  fill?: string | Function,
}

const ArrowSVG = ({ fill }: ArrowSVGProps) => {
  const IconGroup = styled.g`
    fill: ${fill || arrowTheme};
  `
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="10"
    >
      <g
        fill="none"
        fillRule="evenodd"
      >
        <IconGroup transform="translate(-310 -15)">
          <path
            d="M315.655 19.951l.002.002-4.95 4.95-.707-.707 4.244-4.245L310
          15.707l.707-.707 4.95 4.95z"
          />
        </IconGroup>
      </g>
    </svg>
  )
}
ArrowSVG.defaultProps = {
  fill: arrowTheme,
}

type ArrowProps = {
  position?: 'left' | 'right',
}

const Arrow = ({ position }: ArrowProps) => (
  <div className="p2">{position === 'left' ? '👈' : <ArrowSVG />}</div>
)
Arrow.defaultProps = {
  position: 'right',
}

export default Arrow



// WEBPACK FOOTER //
// ./src/scenes/feed/arrow/index.js